"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellSpace = void 0;
const core_1 = require("@openhps/core");
const CellBoundary_1 = require("./CellBoundary");
const SymbolicSpace_1 = require("../SymbolicSpace");
const Slant_1 = require("./Slant");
let CellSpace = class CellSpace extends SymbolicSpace_1.SymbolicSpace {
    constructor() {
        super(...arguments);
        this.boundaries = [];
    }
    setFloor(floor) {
        this.parent = floor;
        this.priority = floor.priority + 1;
        return this;
    }
    set parent(floor) {
        super.parent = floor;
    }
    get parent() {
        return super.parent;
    }
    setArrayBounds(localBounds) {
        if (localBounds.length > 0 && localBounds[0] instanceof core_1.GeographicalPosition) {
            return super.setArrayBounds(localBounds);
        }
        const bounds = localBounds.map((bound) => {
            const vector = bound.toVector3();
            return new core_1.Absolute3DPosition(vector.x, vector.y, 0);
        });
        if (this.parent && this.parent.ceilingHeight) {
            bounds.push(...bounds.map((bound) => {
                const clonedBound = bound.clone();
                clonedBound.z = clonedBound.z + this.parent.ceilingHeight;
                return clonedBound;
            }));
            if (localBounds.length === 2) {
                bounds.splice(1, 2);
            }
        }
        super.setArrayBounds(bounds);
        return;
    }
};
exports.CellSpace = CellSpace;
__decorate([
    (0, core_1.SerializableArrayMember)(CellBoundary_1.CellBoundary),
    __metadata("design:type", Array)
], CellSpace.prototype, "boundaries", void 0);
__decorate([
    (0, core_1.SerializableMember)(),
    __metadata("design:type", Slant_1.Slant)
], CellSpace.prototype, "slant", void 0);
exports.CellSpace = CellSpace = __decorate([
    (0, core_1.SerializableObject)()
], CellSpace);
//# sourceMappingURL=CellSpace.js.map